import { firebaseSlice } from "./reducer";

export const { hydrateStore, setCheckDate, setRemainingVideoUsage } =
  firebaseSlice.actions;
